module.exports = __webpack_public_path__ + "static/media/Review.8c72f97e.png";